import api from "@/services/api.service";

/** Room Board: one request returns the whole operational day. */
export const roomBoardModule = {
    namespaced: true,
    actions: {
        getBoard(actions, request) {
            request = (request || {});
            request.buids = actions.rootGetters['data/getSelectedBranchesIds'];
            return new Promise(function (resolve, reject) {
                api.sendRequest('roomBoard/get', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
    }
}
